import { invokeWithRetry } from './common/invokeWithRetry';

export interface AdminWelcomeMessage {
  id: string;
  title: string;
  body: string;
  gym_ids: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface WelcomeGymOption {
  id: string;
  name: string;
  city: string | null;
}

export interface AdminWelcomeMessageInput {
  id?: string;
  title: string;
  body: string;
  gym_ids: string[];
  is_active: boolean;
}

export type VisibleWelcomeMessage = Pick<AdminWelcomeMessage, 'id' | 'title' | 'body' | 'updated_at'>;

const FN = 'admin-welcome-messages';

async function call<T>(body: Record<string, unknown>): Promise<T> {
  const result = await invokeWithRetry<T>(FN, body);
  if (result.error || !result.data) throw result.error ?? new Error('Empty response');
  return result.data;
}

export const adminWelcomeMessagesApi = {
  list: () => call<{ messages: AdminWelcomeMessage[]; gyms: WelcomeGymOption[] }>({ action: 'list' }),
  upsert: (message: AdminWelcomeMessageInput) =>
    call<{ message: AdminWelcomeMessage }>({ action: 'upsert', message }),
  remove: (id: string) => call<{ success: boolean }>({ action: 'delete', id }),
  getForAdmin: (gymId: string) =>
    call<{ messages: VisibleWelcomeMessage[] }>({ action: 'get_for_admin', gym_id: gymId }),
};
